/** List of sucursales */
export const GET_SUCURSALES_LIST_REQUEST = 'GET_SUCURSALES_LIST_REQUEST';
export const GET_SUCURSALES_LIST_SUCCESS = 'GET_SUCURSALES_LIST_SUCCESS';

/** Sucursales form */
export const SET_SUCURSAL_REQUEST = 'SET_SUCURSAL_REQUEST';
export const SET_SUCURSAL_SUCCESS = 'SET_SUCURSAL_SUCCESS';
export const GET_SUCURSALES_MODAL = 'GET_SUCURSALES_MODAL';
export const HIDE_SUCURSALES_MODAL = 'HIDE_SUCURSALES_MODAL';

/** Error */
export const GET_SUCURSALES_ERROR = 'GET_SUCURSALES_ERROR';